module.exports = __webpack_public_path__ + "static/media/i_pad_pro@3x.5bf8510d.jpg";